import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { merge, pick, split, join, findIndex, omit, isEmpty, filter} from 'lodash';
import { combineOptions, checkDefaultForPending } from '@utils';
import { defaultProduct, defaultVariant, userColumns } from '@utils/recordHelpers';
import { AppProvider, Page, Frame } from '@shopify/polaris';
import { ViewMinor, ArchiveMinor } from '@shopify/polaris-icons';
import translations from '@shopify/polaris/locales/es.json';
import axiosRails from '@utils/axios';

import { ProductForm } from '@presentational';
import { withFormik } from 'formik';

const propTypes = {
  product: PropTypes.object.isRequired,
  submitURL: PropTypes.string.isRequired,
  warranties: PropTypes.array.isRequired,
  // defaultWarrantyId: PropTypes.number.isRequired,
  variantTypes: PropTypes.array.isRequired,
  weightUnits: PropTypes.array.isRequired,
  progress: PropTypes.number,
  nextAction: PropTypes.string,
  nextStatus: PropTypes.string,
  init_image_order: PropTypes.array,
  
  title: PropTypes.string.isRequired,
  // Update only props below
  update: PropTypes.bool,
  hasDefaultVariant: PropTypes.bool,
  readOnly: PropTypes.bool,
  deleteURL: PropTypes.string,
  onlineStoreURL: PropTypes.string,
  checkApbURL: PropTypes.string, // TO be implemented.
  canToggleAPB: PropTypes.bool.isRequired,
  canUpdateArchivedStatus: PropTypes.bool.isRequired,
  updateArchivedStatusURL: PropTypes.string.isRequired,
  archived: PropTypes.bool.isRequired,

  logsURL: PropTypes.string,
};

const defaultProps = {
  readOnly: false,
  progress: 0,
  hasDefaultVariant: false,
}

class ProductFormWrapper extends Component {
  constructor(props) {
    super(props);
    this.state={
      variantState: {
        editingVariant: false,
        selectedVariant: null,
      },
      loading: false,
      ...pick(props, ['progress', 'nextAction', 'nextStatus']), // initialize these
      // defaultValues: props.update ? props.warranty : merge(props.warranty, defaultProduct),
      readOnly: props.readOnly,

      previewImageSrc: "", 
      displayApbConfirmation: false,
      archivedLabel: this.props.archived ? 'Desarchivar' : 'Archivar'
    }
  }
  //  ______________________________________________
  // _____________________RENDER_____________________
  //  ______________________________________________
  render() {
    // let { product, warranties, variantTypes, weightUnits, update } = this.props;
    let { readOnly } = this.state;

    let renderProps = {
      handleChange: this.handlePolarisChange,
      handleChangeNumber: this.handleChangeNumber,
      handleOptionValuesChange: this.handleOptionValuesChange,

      openImagePreview: this.openImagePreview,
      closeImagePreview: this.closeImagePreview,

      openApbConfirmation: this.openApbConfirmation,
      closeApbConfirmation: this.closeApbConfirmation,

      toggleValue: this.toggleValue,
      createMixedImageList: this.createMixedImageList,
      onImageDrag: this.onImageDrag,
      onImageUpload: this.onImageUpload,
      onImageDelete: this.onImageDelete,
      removeRemoteImage: this.removeRemoteImage,

      onVariantClick: this.onVariantClick,
      readOnly, // will be change later into the state
      closeVariantModal: this.closeVariantModal,
      saveVariantChanges: this.saveVariantChanges,
      onApprove: this.onApprove,
      onReject: this.onReject,

      closeToast: this.closeToast,
      reloadVariants: this.handleVariantChange,

      ...this.state.variantState, // values of the object at once
      ...pick(this.state, ['nextAction', 'nextStatus', 'progress', 'loading', 'previewImageSrc', 'displayApbConfirmation', 'approvalStatus']),
      ...pick(this.props, [
        'setFieldValue', 'values', 'handleSubmit', 'errors', 'warranties', 'variantTypes', 'product', 'weightUnits', 'update', 'hasDefaultVariant', 'status', 'variantsURL', 'isAdmin', 
        'deleteURL', 'locationName', "canToggleAPB"
      ]), // formik stuff and other props
    }

    let secondaryActions = [];

    // If NIL the product is currently not published
    if (!!this.props.onlineStoreURL) {
      secondaryActions.push({
        content: I18n.t("actions.show"),
        accessibilityLabel: 'Ver en online store',
        icon: ViewMinor,
        external: true,
        url: this.props.onlineStoreURL
      });
    }

    // Archive / Unarchive
    if (this.props.canUpdateArchivedStatus) {
      secondaryActions.push({
        content: this.state.archivedLabel,
        icon: ArchiveMinor,
        onAction: this.updateArchivedStatus
      });
    }

    // Changelogs URL
    console.log("LURL", this.props.logsURL);
    if(this.props.logsURL){
      secondaryActions.push({
        content: I18n.t("activerecord.models.changelog.one"),
        accessibilityLabel: I18n.t("activerecord.models.changelog.one"),
        icon: ViewMinor,
        external: true,
        url: this.props.logsURL,
      });
    }

    console.log(this.props.product)

    return (
      <AppProvider i18n={translations}>
        <Frame>
          <Page
            breadcrumbs={ [{content: I18n.t("actions.back"), url: '/products'}] }
            secondaryActions={ secondaryActions }
            title={ this.props.title }
            subtitle={this.props.product && this.props.product.user && this.props.product.user.vendor}
          >
            <ProductForm
              {...renderProps} />
          </Page>
        </Frame>
      </AppProvider>
    );
  }

  handlePolarisChange = (value, id) => {
    let { setFieldValue } = this.props;
    setFieldValue(id, value);
  }

  // For selects which always cast the value into string (which cause problems with IDs)
  handleChangeNumber = (value, id) => {
    this.handlePolarisChange(Number(value), id);
  }

  toggleValue = (field) => {
    let { values, setFieldValue } = this.props;
    setFieldValue(field, !values[field]);
  }

  onImageDrag = (dragResult) => {
    // dropped outside the list
    if (!dragResult.destination) {
      return;
    }

    const startIndex = dragResult.source.index;
    const endIndex = dragResult.destination.index;

    if( startIndex == endIndex ){
      return;
    }

    const { values, setFieldValue } = this.props;

    let newImgOrderList = [...values.image_order]; // cloned
    const [removed] = newImgOrderList.splice(startIndex, 1);
    newImgOrderList.splice(endIndex, 0, removed);

    setFieldValue("image_order", newImgOrderList);
  }

  createMixedImageList = () => {
    // renders based on the current order not on the existing images
    // it means it does not render new images if they are not listed.
    
    let newList = [];
    //const { values } = this.props;
    const values = this.props.values; // not cloned

    values.image_order.map((item) => {
      if(item[0] == 0) {
        newList.push( values.images[item[1]] );
      } else {
        newList.push( values.local_images[item[1]] );
      }
    });
    
    return newList;
  }

  onImageUpload = (files, acceptedFiles, rejectedFiles) => {

    if(rejectedFiles.length) return;
    
    const { values, setValues } = this.props;

    acceptedFiles.forEach( item => {
      item["uniqTempName"] = item["name"] + parseInt(Math.random()*1000); // unique name
    });

    setValues({
      ...values,
      "image_order": [...values.image_order, [1, values.local_images.length] ],
      "local_images": [
        ...values.local_images,
        ...acceptedFiles,
      ],
    });
  }

  eraseImageFromOrder = (index, listName) => {
    // Get the current amount of images
    let {image_order} = this.props.values; // cloned

    let listValue = listName == "images" ? 0 : 1;

    // reduce by 1 the indexes of elements of the specific List
    // that are after the element erased.
    image_order.forEach((data, i, ogArray) =>{
      // ogArray points/equals to image_order
      if(data[0] == listValue) {
        if(data[1] > ogArray[index][1]) {
          ogArray[i][1] -= 1; // modify the right memory "image_order" and not its copy "data"
        }
      }
    });

    image_order.splice(index, 1); // remove the element.

    return image_order;
  }

  // TODO OPTIMIZE THE list item removal
  onImageDelete = (imageUniqName, index) => {
    let { values, setValues } = this.props;

    let newList = filter(values["local_images"], (item) => item.uniqTempName != imageUniqName );

    setValues({
      ...values,
      "image_order": this.eraseImageFromOrder(index, "local_images"),
      "local_images": newList,
    });
  }

  removeRemoteImage = (id, index) => {
    let { values, setValues } = this.props;
    let newList = filter(values["images"], (item) => item.id != id );

    setValues({
      ...values,
      "image_order": this.eraseImageFromOrder(index, "images"),
      "images": newList,
    });
  }

  openImagePreview = (src) => {
    this.setState({ previewImageSrc: src });
  }

  closeImagePreview = () => {
    this.setState({ previewImageSrc: "" })
  }

  openApbConfirmation = (src) => {
    this.setState({ displayApbConfirmation: true });
    // await axiosRails.get("checkToggleURL")
  }

  closeApbConfirmation = (src) => this.setState({ displayApbConfirmation: false });

  postToast = (message) => {
    const { status, setStatus } = this.props;
    setStatus({
      ...status,
      showToast: true,
      toastContent: message
    });
  }

  closeToast = () => {
    const { status, setStatus } = this.props;
    setStatus({
      ...status,
      showToast: false,
    })
  };

  // handleOptionValuesChange = (name, value) => {
  //   let { setFieldValue } = this.props;
  //   let tags = split(value, ",");
  //   setFieldValue(name, tags); // save as array
  // }

  handleOptionValuesChange = async (name, tags) => {
    let { setFieldValue } = this.props;
    await setFieldValue(name, tags); // save as array
    this.handleVariantChange();
  }

  handleVariantChange = () => {
    let { values, setFieldValue } = this.props;
    let { variants, options, sku, barcode, weight, weight_unit, inventory_quantity, publish_price, barulu_cost } = values;
    let multipleOptions = options.length > 1;
    let combinations = combineOptions(options);

    let newVariants = combinations.map( (selectedOptions, index) => ({
      ...defaultVariant,
      id: 0 - index,
      sku: Boolean(sku) ? `${sku}-${index}` : "",
      barcode: index == 0 ? barcode : "", // only first variant inherit barcode (from Shopify default behavior)
      inventory_quantity: inventory_quantity || 0,
      selected_options: typeof(selectedOptions) == "string" ? [selectedOptions] : selectedOptions,
      title: multipleOptions ? join(selectedOptions, " • ") : selectedOptions,
      weight,
      weight_unit,
      price: publish_price,
      unit_cost: barulu_cost,
    }))
    setFieldValue("variants", newVariants);
  }

  onVariantClick = (id) => {
    let { values } = this.props;
    let formIndex = findIndex(values.variants, ['id', id]);
    let variant = values.variants[formIndex];
    this.setState({
      variantState: {
        selectedVariant: variant,
        editingVariant: true,
        variantIndex: formIndex,
      }
    });
  }

  saveVariantChanges = () => {

  }

  closeVariantModal = () => {
    this.setState({
      variantState: {
        selectedVariant: {},
        editingVariant: false
      }
    })
  }

  onApprove = async () => {
    let { approveURL, values, setFieldValue, setErrors } = this.props;
    let { nextStatus } = this.state;
    if(!nextStatus)
      return false
    await this.setState({ loading: true });
    try {
      let response = await axiosRails.post(approveURL, {
        nextStatus,
        currentStatus: values.status,
      });
  
      let data = response.data;
      
      // Extra errors handling (not validations)
      if(!!data.extra_errors && data.extra_errors.length > 0){
        this.postToast(data.extra_errors);
      }
      else{
        this.postToast(data.message);
      }

      // Success block
      if (data.success) {
        window.location = data.redirectURL;
      }
      else {
        setErrors(data.errors || {}) // Set validation errors
      }
      
      // Always executed block on valid response.
      await this.setState({
        nextStatus: data.status_info.next_status,
        progress: data.status_info.progress,
        nextAction: data.status_info.action_name,
        approvalStatus: data.status, // Used instead values.status. read below
        // readOnly: true,
      });
      // await setFieldValue("status", data.status); // // setFieldValue status doesn't go well with setErrors because it is internally async and flag as modified the field so the errors goes away.
    } catch (error) {
      // ...to be implemented
    }
    await this.setState({ loading: false });
  }

  onReject = async () => {
    let { rejectURL, setFieldValue } = this.props;
    let { nextStatus } = this.state;
    if(!nextStatus)
      return false
    let response = await axiosRails.post(rejectURL, {});
    let data = response.data;
    
    this.postToast(data.message);
    if(data.success){
      // alert("Successful rejection")
    }
    else{
      // alert("NOPE");  
    }
    await this.setState({
      nextStatus: data.status_info.next_status,
      progress: data.status_info.progress,
      nextAction: data.status_info.action_name,
      approvalStatus: data.status,
    });
  }

  updateArchivedStatus = async () => {
    let response = await axiosRails.put(this.props.updateArchivedStatusURL);
    let data = response.data;

    this.postToast(data.message);

    this.setState({ archivedLabel: data.archived ? 'Desarchivar' : 'Archivar' });
  }
}

const initialFormikStatus = {
  submitLoading: false,
  showToast: false,
  toastContent: ""
}

// ==================================================================================
// ======================= WITH FORMIK. INIT AND handleSubmit =======================
// ==================================================================================
const FormWithFormik = withFormik({
  mapPropsToValues: (props) => {

    if(props.update){

      // unique name - frontEnd only.
      props.product.local_images.forEach( item => {
        item["uniqTempName"] = item["name"] + parseInt(Math.random()*1000);
      });

      return {
        ...props.product,
        image_order: props.init_image_order || [],
      }
    
    } else {
      return {
        ...merge(props.product, defaultProduct),
        description_html: '',
        image_order: props.init_image_order || [],
      }
    }
  },

  mapPropsToStatus: (props) => (initialFormikStatus),
  

  handleSubmit: async (values, formikBag) => {
    const { setStatus } = formikBag;
    const { submitURL, update, hasDefaultVariant, defaultVariant } = formikBag.props;

    setStatus({
      submitLoading: true
    })

    // reorder images before sending them to the backEnd to save them ordered.
    let liveImages = values.images;
    let localImages = values.local_images;
    let orderedLiveImages = [];
    let orderedLocalImages = [];
    
    // The new indices are for syncing in the backend.
    // In the backEnd the lists are ordered together to sync with Shopify
    // but image_order's indices has changed.
    let newImageOrder = [];
    let liveImageIndex = -1; // -1 += 1 equals zero, the first index.
    let localImageIndex = -1;

    values.image_order.forEach( data =>{
      let imageIndex = data[1];
      if(data[0] == 0) {
        orderedLiveImages.push(liveImages[imageIndex]);
        liveImageIndex += 1;
        newImageOrder.push([0, liveImageIndex]);
      } else {
        orderedLocalImages.push(localImages[imageIndex]);
        localImageIndex += 1;
        newImageOrder.push([1, localImageIndex]);
      }
    });
    // end of reorder

    let dataValues = {
      ...omit(values,['image_order', 'images', 'local_images']),
      description_html: values.description_html,
      images: orderedLiveImages,
      image_order: newImageOrder,
    }

    if(update){
      // Update special logic

      // Setup default variant changes For products with the default variant!! Pending publish product(which do not own default variant yet) should only send the product data without any variant info.
      // SPECIAL CASE. If transitioning from Default variant to Variants then change to handler of variants update. (else clause)
      const onlyDefaultVariant = checkDefaultForPending(values);  // Values == product

      // Update of default variant
      if(hasDefaultVariant && !isEmpty(defaultVariant) && onlyDefaultVariant ){
        let defaultVariantValues = {
          id: defaultVariant.id,
          ...pick(values, ['weight', 'weight_unit', 'sku', 'barcode', 'inventory_quantity']), // From form editables to variant
          price: values.publish_price,
          unit_cost: values.barulu_cost,
        }
        dataValues = {
          ...dataValues,
          variants_attributes: [ defaultVariantValues ]
        }
      }
      // Originally Default variant but have new variants. Some values are toggled on ProductForm.
      else if(hasDefaultVariant && !!values.default_variant_data && values.changingToVariants ){ 
        let updateVariants = values.variants.map( (variant) => omit(variant, ['id']) ); // Normal Update sends existing variants while default-to-variants are new variants
        updateVariants = [
          ...updateVariants, // New ones
          { id: values.default_variant_data.variant.id, _destroy: true } // Kill default_variant
        ];
        
        let updateOptions = [
          ...values.options, // New ones
          { id: values.default_variant_data.option.id, _destroy: true }
        ];

        dataValues = {
          ...dataValues,
          variants_attributes: updateVariants,
          options_attributes: updateOptions,
        }
      }
      // Clean update. (Used for non published and published with variants)
      else{
        // There is a special case when a non published product gets variants after the first save and failed. The variants ids must be removed for variant with artificial ids (which are negative or 0). Real variants have positive values! and keep their own id.
        let updateVariants = values.variants.map( (variant) => {
          if(variant.id <= 0){
            return omit(variant, ['id']) 
          }
          else
            return variant
        });
        dataValues = {
          ...dataValues,
          variants_attributes: updateVariants,
          options_attributes: values.options,
        }
      }
    }
    else{
      // Variants and Options can be directly added on create.
      // Remove artificial ids
      dataValues = {
        ...dataValues,
        variants_attributes: values.variants.map( (variant) => omit(variant, ['id']) ),
        options_attributes: values.options,
      }
    }
    
    let formData = new FormData();

    //for(let file of values.local_images){
    for(let file of orderedLocalImages){
      delete file.uniqTempName;
      formData.append("local_images[]", file, file.name);
    }

    // formData.append("local_images", values.local_images, values.local_images && "values.local_images.name");
    let productData = JSON.stringify(dataValues); // Main data
    formData.append("productData", productData);
    
    // Submit logic
    try {
      let response = await axiosRails({
        method: update ? "PUT" : "POST",
        data: formData,
        url: submitURL
      });

      let { data, status } = response;

      if(data.message){
        formikBag.setStatus({
          submitLoading: data.success, // On success keep loading to avoid another submit while redirecting.
          showToast: true,
          toastContent: data.message
        })
      }

      if(data.success){
        window.location = data.redirectURL;
        return true
      }
      else{
        formikBag.setErrors(data.errors || {});
      }
    } 
    catch (error) {
      formikBag.setStatus({
        submitLoading: false,
        showToast: true,
        toastContent: I18n.t("app.messages.request_error")
      })
      console.error("E",error);
    }

  }
})(ProductFormWrapper)


ProductFormWrapper.propTypes = propTypes;
ProductFormWrapper.defaultProps = defaultProps;


export default FormWithFormik;